import { render } from "./ReferenceDetails.vue?vue&type=template&id=1f7012d8&scoped=true"
import script from "./ReferenceDetails.vue?vue&type=script&lang=js"
export * from "./ReferenceDetails.vue?vue&type=script&lang=js"

import "./ReferenceDetails.vue?vue&type=style&index=0&id=1f7012d8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7012d8"]])

export default __exports__